module.exports = __webpack_public_path__ + "static/24-Samsung-579e4dc5f952c53c8f3ab70ad88a92ce.png";